import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import SkeletonTable from "@/components/SkeletonTable"
import { getListSumberListrik } from "@/services/getData"

export default function MasterSumberListrikPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listSumberListrik"],
    queryFn: getListSumberListrik,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
